import { render, staticRenderFns } from "./ResultProblem.vue?vue&type=template&id=9be0a43c&scoped=true&lang=pug&"
import script from "./ResultProblem.vue?vue&type=script&lang=ts&"
export * from "./ResultProblem.vue?vue&type=script&lang=ts&"
import style0 from "./ResultProblem.vue?vue&type=style&index=0&id=9be0a43c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be0a43c",
  null
  
)

export default component.exports